export class GetServicePlanBO {
    orderColumn: string = "ClientName";
    orderType: string = "asc";
    pageitem: number = 10;
    currentpageno: number = 1;
    agencyID: number;
    field: string = "ClientName";
    value: string = "";
    matchCase: boolean = false;
    status:string;
    type:string="string";
    clientId:string;
    operator: string = "contains";
    isApproved:boolean|null;

}

export class ChangeSdpStatusBO {
    sdpIds: string[];
    status: boolean;
  }

  export class permission{
    sdpcreate:boolean;
    sdpupdate:boolean;
    sdpdelete:boolean;
  }
  export class SDP {
    serviceDeliveryPlanId : string =  "00000000-0000-0000-0000-000000000000";
    fileString: string;
    sdpDocFilepath: string;
    plandate : string;
    version : string;
    startdate : string;
    enddate : string;
    totalCFSSUnitsEligible : number;
    modelTypename : string ;
    clientId:string;

  }
  export class GetSDPReportBO {
    orderColumn: string = "ClientName";
    orderType: string = "asc";
    pageitem: number = 10;
    currentpageno: number = 1;
    agencyID: number;
    field: string = "ClientName";
    value: string = "";
    matchCase: boolean = false;
    type:string="string";
    operator: string = "contains";
    fromdate: string;
    todate: string;

}